import { Validators } from "@angular/forms";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import * as moment from "moment";
import { ColumnChartService } from "./column-chart.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { format } from "path";
// moment.locale("es");

@Component({
  selector: "app-column-chart",
  templateUrl: "./column-chart.component.html",
  styleUrls: ["./column-chart.component.scss"],
})
export class columnChartComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    public spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private columnChartService: ColumnChartService
  ) {}
  @Input() listColumn = [];
  @Input() queryId: string;
  @Input() basedOnId: string;
  @Input() queryConfigType: string;
  @Input() selectTypeGraphic;
  @Input() arguments = [];
  @Input() selectTypeGrafico: string;
  @Output() onVewGraphic: EventEmitter<any> = new EventEmitter<any>();
  registerColumnForm: FormGroup;
  returnBoolean = false;
  datoFormater;
  validator = true;
  newObject: any;
  controls: any;
  vValues = false;
  oValues = false;
  submitted = false;
  dataGraphic: any = {};
  objectGraphic: any = {};
  objectoFinal = [];
  columnObject;
  msgSpiner = "Cargando...";
  positionList = [
    { name: "right", title: "Derecha" },
    { name: "left", title: "Izquierda" },
    { name: "top", title: "Arriba" },
    { name: "bottom", title: "Abajo" },
  ];
  message = {
    message: null,
    class: null,
  };
  estilosColumn = [
    { name: "Basic Column", title: "Basic Column" },
    { name: "Column With DataLabels", title: "Column With DataLabels" },
    { name: "Column with Rotated Labels", title: "Column with Rotated Labels" },
    { name: "Distributed Columns", title: "Distributed Columns" },
  ];

  objectFinal = {
    series: [],
    chart: {
      background: "",
      height: 700,
      width: 700,

      type: "bar",
      zoom: {
        enabled: true,
      },
      toolbar: {
        show: true,
        offsetX: 0,
        offsetY: 0,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true,
          customIcons: [],
        },
        export: {
          csv: {
            filename: undefined,
          },
          svg: {
            filename: undefined,
          },
          png: {
            filename: undefined,
          },
        },
        autoSelected: "zoom",
      },
    },
    legend: {
      show: true,
      floating: false,
      fontSize: "12px",
      position: "right",
      offsetX: 0,
      offsetY: 10,
      labels: {
        useSeriesColors: false,
      },
      // formatter: function (seriesName, opts) {
      //   return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex];
      // },
      itemMargin: {
        horizontal: 3,
      },
    },
    dataLabels: {
      enabled: true,
    },
    stroke: {
      curve: "straight",
    },
    title: {
      text: "",
      align: "left",
    },
    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: [],
    },
  };

  ngOnInit() {
    this.registerColumnForm = this.formBuilder.group({
      column: [null, [Validators.required]],
      date: [null, [Validators.required]],
      value: [null, [Validators.required]],
      color: ["transparent", [Validators.required]],
      position: [{ name: "bottom", title: "Abajo" }, [Validators.required]],
      title: ["Titulo de ejemplo", [Validators.required]],
      estilosColumn: [
        { name: "Basic Column", title: "Basic Column" },
        [Validators.required],
      ],
      dataLabels: [null],
    });
    this.controls = this.registerColumnForm.controls;
  }

  showGraphic() {
    this.submitted = true;

    this.spinner.show();

    if (this.registerColumnForm.invalid) {
      this.message = {
        message: "Todos los campos son obligatorios",
        class: "alert alert-danger mt-2",
      };
      setTimeout(() => {
        this.message = {
          message: null,
          class: null,
        };
      }, 3000);
    }
    switch (this.registerColumnForm.controls.estilosColumn.value.name) {
      case "Basic Column":
        this.newObject = {
          ...this.objectFinal,
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "55%",
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },
          fill: {
            opacity: 1,
          },
        };
        break;
      case "Column With DataLabels":
        this.newObject = {
          ...this.objectFinal,
          plotOptions: {
            bar: {
              dataLabels: {
                position: "top", // top, center, bottom
              },
            },
          },
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return val + "%";
            },
            offsetY: -20,
            style: {
              fontSize: "12px",
              colors: ["#304758"],
            },
          },
          xaxis: {
            type: "datetime",
            position: "top",
            labels: {
              offsetY: -18,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
            crosshairs: {
              fill: {
                type: "gradient",
                gradient: {
                  colorFrom: "#D8E3F0",
                  colorTo: "#BED1E6",
                  stops: [0, 100],
                  opacityFrom: 0.4,
                  opacityTo: 0.5,
                },
              },
            },
          },
          tooltip: {
            x: {},
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "light",
              type: "horizontal",
              shadeIntensity: 0.25,
              gradientToColors: undefined,
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [50, 0, 100, 100],
            },
          },
          yaxis: {
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
            labels: {
              show: false,
              formatter: function (val) {
                return val + "%";
              },
            },
          },
          title: {
            text: "Monthly Inflation in Argentina, 2002",
            floating: 0,
            offsetY: 320,
            align: "center",
            style: {
              color: "#444",
            },
          },
          legend: {
            show: false,
          },
        };
        break;
      case "Column with Rotated Labels":
        this.newObject = {
          ...this.objectFinal,
          legend: {
            show: false,
          },
          plotOptions: {
            bar: {
              columnWidth: "50%",
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            width: 2,
          },

          grid: {
            row: {
              colors: ["#fff", "#f2f2f2"],
            },
          },
          xaxis: {
            categories: [],
            labels: {
              rotate: -45,
            },
            type: "datetime",
            tickPlacement: "on",
          },
          yaxis: {},
          fill: {
            type: "gradient",
            gradient: {
              shade: "light",
              type: "horizontal",
              shadeIntensity: 0.25,
              gradientToColors: undefined,
              inverseColors: true,
              opacityFrom: 0.85,
              opacityTo: 0.85,
              stops: [50, 0, 100],
            },
          },
        };
        break;
      case "Distributed Columns":
        this.newObject = {
          ...this.objectFinal,
          plotOptions: {
            bar: {
              columnWidth: "45%",
              distributed: true,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: false,
          },
          grid: {
            show: false,
          },
          xaxis: {
            type: "datetime",
            categories: [],
            labels: {
              style: {
                fontSize: "12px",
              },
            },
          },
          tooltip: {
            x: {
              format: "dd/MM/yy HH:mm",
            },
          },
        };
        break;
      default:
        break;
    }
    this.newObject.legend.position =
      this.registerColumnForm.controls.position.value.name;
    this.newObject.chart.background =
      this.registerColumnForm.controls.color.value;
    this.newObject.title.text = this.registerColumnForm.controls.title.value;
    this.newObject.chart.toolbar.export.png.filename =
      this.newObject.title.text +
      "-" +
      moment().format("MMMM Do YYYY, h:mm:ss a");
    this.newObject.chart.toolbar.export.svg.filename =
      this.newObject.title.text +
      "-" +
      moment().format("MMMM Do YYYY, h:mm:ss a");
    this.newObject.chart.toolbar.export.csv.filename =
      this.newObject.title.text +
      "-" +
      moment().format("MMMM Do YYYY, h:mm:ss a");

    this.controls.dataLabels.value === null
      ? (this.newObject.dataLabels.enabled = false)
      : (this.newObject.dataLabels.enabled = true);

    this.registerColumnForm.reset;
    //  this.objectFinal = "";
    //Peticion del grafico
    this.columnChartService
      .onGetDataGraphic(
        this.queryId,
        this.basedOnId,
        this.arguments,
        this.queryConfigType
      )
      .subscribe(
        (res: any) => {
          this.objectGraphic = this.getDataGrafic(res);
          this.datoFormater = this.getDateSeries(res);
          // const [{ dataSerie, dateFormat }] = this.objectGraphic;
          console.log("pipo martinez", this.objectGraphic);
          console.log("pipo martinez2", this.datoFormater);
          // this.newObject.series = this.objectGraphic.series;
          // this.newObject.labels = this.objectGraphic.labels;
          this.newObject.series = this.objectGraphic;
          this.newObject.xaxis.categories = this.datoFormater;

          //Se emitirá al componente contenedor el objeto grafico, para posteriormente visializarlo
          this.onVewGraphic.emit(this.newObject);
           this.selectTypeGrafico = "";
        },
        (err) => {
          this.toastr.error(
            "Error consulta de datos del grafico Column: " + err
          );
          this.spinner.hide();
          console.log("Error consulta de dtos del grafico Column: ", err);
        }
      );
    this.spinner.hide();
  }

  getDataGrafic(restultGrid) {
    let datos = restultGrid.data;
    let objectResult;
    let resultl = [];
    let prueba = [];
    let object = [];
    let posible = [];
    let seriesUnicas = [];
    let catergoriasUnicas = [];
    let nombreSeries = [];
    let result = [];
  
    let funcion = [];

    // console.log("primero console", datos);

    datos.forEach((element) => {
      let series = element[this.registerColumnForm.controls.column.value.field];
      seriesUnicas.push(series);
      let categories =
        element[this.registerColumnForm.controls.date.value.field];
      catergoriasUnicas.push(categories);
    });
    const valorSeriesUnicas = seriesUnicas.reduce((acc, item) => {
      if (!acc.includes(item)) {
        acc.push(item);
      }
      return acc;
    }, []);
    const valorcatergoriasUnicas = catergoriasUnicas.reduce((acc, item) => {
      if (!acc.includes(item)) {
        acc.push(item);
      }
      return acc;
    }, []);

    const valornombreSeries = nombreSeries.reduce((acc, item) => {
      if (!acc.includes(item)) {
        acc.push(item);
      }
      return acc;
    }, []);

    console.log("nombreSeries", valornombreSeries);
    console.log("series unicas", valorSeriesUnicas);
    console.log("categorias unicas", valorcatergoriasUnicas);
    valorSeriesUnicas.forEach((series) => {
      console.log("ejemplo", series);

       result = datos.filter(
        (data) =>
          data[this.registerColumnForm.controls.column.value.field] === series
      );

      console.log(result);
      if (series == null) {
        series = "Null";
        funcion = this.datosTratar(result, series);
      }
      funcion = this.datosTratar(result, series);
    });
    console.log(funcion)
     return funcion
  }

  datosTratar(visaul, series) {
    let data = [];
    let formato = {};
    visaul.forEach((element) => {
      if (
        element[this.registerColumnForm.controls.value.value.field] === null ||
        undefined
      ) {
        data.push((this.registerColumnForm.controls.value.value.field = 0));
      }
      data.push(element[this.registerColumnForm.controls.value.value.field]);
    });

     formato = {
      name: series,
      data: data,
    };
  
    this.objectoFinal.push(formato);
    console.log(this.objectoFinal);
     return this.objectoFinal;
  }

  getDateSeries(date) {
    this.objectoFinal =[];
    let moreDate = date.data;
    let result = [];
    let objectResult: any = [];
    moreDate.forEach((element) => {
      // console.log(element);
      result = element[this.registerColumnForm.controls.date.value.field];
      objectResult.push(result);
    });

    const asd = objectResult.reduce((acc, item) => {
      if (!acc.includes(item)) {
        acc.push(item);
      }
      return acc;
    }, []);

    console.log(asd);
    return asd;
  }

}
